<template>
  <a-button
    icon="book"
    size="small"
    type="link"
    @click="e => $emit('click', e)"
    style="color: #096dd9"
  >
    生成工单
  </a-button>
</template>

<script>
export default {
  name: 'CreateTicketButton'
}
</script>
